<div class="tw-w-full tw-h-full tw-max-h-[100vh] tw-overflow-auto tw-p-5" (scroll)="onScroll($event)">
  <app-menu-mobile></app-menu-mobile>
  <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xl tw-text-secondary tw-mb-5">{{ "orders" | translate }}</p>
  <div class="tw-w-full tw-h-fit tw-flex max-md:tw-justify-end tw-flex-wrap-reverse md:tw-flex-wrap tw-gap-4 tw-mb-5">
    <div class="tw-w-full md:tw-max-w-72 tw-h-12 tw-relative tw-flex tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-auto tw-px-4 tw-py-3">
      <input
        #searchInput
        class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-bg-transparent tw-text-secondary tw-outline-none tw-pr-8"
        [(ngModel)]="search"
        (change)="setSearch($event)"
        [placeholder]="'search-here' | translate"
      />
      <img class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" src="../../../assets/search-icon.svg" />
    </div>
    <p-dropdown
      class="tw-border tw-border-grey-600 tw-rounded-[5px]"
      [options]="branches"
      [(ngModel)]="selectedBranch"
      optionLabel="name"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      [placeholder]="'select-branch' | translate"
      (onFilter)="searchBranches.next($event.filter)"
      [emptyFilterMessage]="searchBranchNoResults | translate"
      (onChange)="setBranch($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.name }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <p-dropdown
      class="tw-border tw-border-grey-600 tw-rounded-[5px]"
      [options]="riders1"
      [(ngModel)]="selectedRider"
      optionLabel="fullName"
      [filter]="true"
      filterBy="fullName"
      [showClear]="true"
      [placeholder]="'assigned-to' | translate"
      (onFilter)="searchRiders1.next($event.filter)"
      [emptyFilterMessage]="searchRider1NoResults | translate"
      (onChange)="setAssignedTo($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.fullName }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.fullName }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <div class="status-columns tw-w-full tw-h-fit tw-min-h-96 tw-relative tw-flex tw-rounded-[5px] max-md:tw-overflow-x-auto md:tw-overflow-visible">
    <div *ngIf="isLoading" class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-bg-black/50 tw-z-50">
      <div class="tw-w-full tw-h-96 tw-flex tw-justify-center tw-items-center">
        <p class="tw-font-poppins tw-font-medium tw-text-sm tw-text-white">{{ "loading" | translate }}</p>
      </div>
    </div>
    <div
      class="status-column tw-shrink-0 tw-box-border md:tw-min-w-80 md:tw-grow md:tw-basis-0 tw-border-y tw-border-l tw-border-secondary"
      *ngFor="let status of statuses; let i = index"
      [ngStyle]="{ 'background-color': status.color }"
      [ngClass]="{
        'tw-rounded-l-[5px]': i === 0,
        'tw-rounded-r-[5px] tw-border-r': i === statuses.length - 1,
        'max-md:tw-rounded-[5px] max-md:tw-border-r': true,
      }"
    >
      <div class="tw-w-full tw-h-fit tw-flex tw-flex-col">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-lg tw-text-secondary tw-text-center tw-border-b tw-border-secondary tw-mb-2">
          {{ status.name | translate }}
        </p>
        <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-2 tw-p-2" [id]="status.id.toString()">
          <div *ngFor="let order of status.orders" class="order-item tw-w-full tw-h-fit tw-relative tw-bg-white tw-border tw-border-secondary tw-rounded-[5px] tw-overflow-visible">
            <div class="order-item-child1 tw-w-full tw-h-14 tw-flex">
              <div (click)="i !== 0 && moveOrder(order, 'left')" class="left-arrow-box" [class.disabled]="i === 0">
                <img class="left-arrow-icon" src="../../../assets/left-arrow.svg" />
                <img class="left-arrow-hover-icon" src="../../../assets/left-arrow-hover.svg" />
              </div>
              <div
                *ngIf="(status.id == 2 || status.id == 3) && order.shipping_type == 'delivery' && !order.table_id"
                class="order-item-grandchild1 qr-code-box"
                [ngClass]="order.shipping_type != 'delivery' || order.table_id ? '!tw-bg-danger/50 tw-cursor-not-allowed' : ''"
              >
                <img class="qr-code-icon" src="../../../assets/qrcode.svg" />
                <img class="qr-code-hover-icon" src="../../../assets/qrcode-hover.svg" />
              </div>
              <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-border-b tw-border-secondary tw-overflow-hidden tw-px-2">
                <div class="tw-flex-1 tw-flex tw-items-center tw-gap-2">
                  <img class="tw-w-4 tw-h-4 tw-object-contain" src="../../../assets/order-id-icon.svg" />
                  <p class="tw-flex-1 tw-max-h-5 tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-break-all tw-overflow-hidden">
                    {{ order.special_id }}
                  </p>
                </div>
                <div class="tw-flex-1 tw-flex tw-items-center tw-gap-2">
                  <img class="tw-w-4 tw-h-4 tw-object-contain" src="../../../assets/price-icon.svg" />
                  <p class="tw-flex-1 tw-max-h-5 tw-font-poppins tw-font-bold tw-text-sm tw-text-secondary tw-break-all tw-overflow-hidden">
                    {{ order.price | mycurrency }}
                  </p>
                </div>
              </div>
              <div (click)="i !== statuses.length - 1 && moveOrder(order, 'right')" class="right-arrow-box" [class.disabled]="i === statuses.length - 1">
                <img class="right-arrow-icon" src="../../../assets/right-arrow.svg" />
                <img class="right-arrow-hover-icon" src="../../../assets/right-arrow-hover.svg" />
              </div>
            </div>
            <div class="order-item-child2 tw-w-full tw-h-fit tw-relative tw-px-4 tw-py-3">
              <div
                *ngIf="(status.id == 2 || status.id == 3) && order.shipping_type == 'delivery' && !order.table_id"
                [class]="
                  'order-item-grandchild2 tw-w-full tw-h-full tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-bg-black/50 tw-z-50 tw-flex-col tw-justify-center tw-items-center tw-gap-3'
                "
              >
                <qrcode [qrdata]="order.special_id" class="tw-flex tw-justify-center tw-items-center" [errorCorrectionLevel]="'M'"></qrcode>
                <button
                  type="button"
                  (click)="$event.stopPropagation(); printOrderQrCode($event, order)"
                  class="tw-flex tw-items-center tw-gap-2 tw-bg-primary hover:tw-bg-primary/90 active:tw-bg-primary/80 tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-border tw-border-secondary tw-rounded-[5px] tw-px-4 tw-py-2 tw-shadow-lg tw-cursor-pointer"
                >
                  {{ "print" | translate }}
                </button>
              </div>

              <div *ngIf="isDeliveryBusiness && order.business && order.branch" class="tw-flex tw-gap-2 tw-mb-3">
                <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-company-icon.svg" />
                <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">{{ order.business.name }} - {{ order.branch.name }}</p>
              </div>
              <div *ngIf="!order.table_id" class="tw-flex tw-gap-2 tw-mb-3">
                <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-user-icon.svg" />
                <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                  {{ order.fullname }}
                </p>
              </div>
              <div *ngIf="!order.table_id" class="tw-flex tw-gap-2 tw-mb-3">
                <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-phone-icon.svg" />
                <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                  {{ order.phone }}
                </p>
              </div>
              <div *ngIf="!order.table_id" class="tw-w-full tw-h-fit">
                <div *ngIf="order.shipping_type == 'delivery'" class="tw-flex tw-gap-2 tw-mb-3">
                  <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-location-icon.svg" />
                  <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                    {{ order.location }}
                  </p>
                </div>
                <div *ngIf="order.shipping_type == 'pickup'" class="tw-flex tw-gap-2 tw-mb-3">
                  <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-pickup-icon.svg" />
                  <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                    {{ "pick-up" | translate }}
                  </p>
                </div>
                <div class="tw-flex tw-gap-2 tw-mb-3">
                  <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-time-icon.svg" />
                  <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                    {{ order.shipping_time == "asap" ? ("asap" | translate) : (order.shipping_date | date: "dd/MM/yyyy HH:mm") }}
                  </p>
                </div>
              </div>
              <div *ngIf="order.table_id" class="tw-w-full tw-h-fit">
                <div class="tw-flex tw-gap-2 tw-mb-3">
                  <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-table-icon.svg" />
                  <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                    {{ ("table" | translate) + ": " + order.table_id }}
                  </p>
                </div>
              </div>
              <div class="tw-flex tw-gap-2 tw-mb-3">
                <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/order-bag-icon.svg" />
                <div class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-break-words tw-overflow-hidden">
                  <div *ngFor="let part of order.description.split('|')" class="tw-mb-2">{{ part.trim() }}<br /></div>
                </div>
              </div>
              <div *ngIf="(status.id == 2 || status.id == 3) && order.shipping_type == 'delivery' && !order.table_id" class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-pt-3 tw-mb-2">
                <p-dropdown
                  *ngIf="order.third_party_id <= 0"
                  class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
                  [options]="riders2"
                  [(ngModel)]="order.assignedTo"
                  optionLabel="fullName"
                  [filter]="true"
                  [readonly]="false"
                  filterBy="fullName"
                  [showClear]="true"
                  [placeholder]="'assigned-to' | translate"
                  (onFilter)="searchRiders2.next($event.filter)"
                  [emptyFilterMessage]="searchRider2NoResults | translate"
                  (onChange)="setOrderAssignedTo(order, $event)"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
                    <div class="flex align-items-center gap-2">
                      <div>{{ selectedOption.fullName }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ item.fullName }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <p-dropdown
                  *ngIf="order.third_party_id > 0"
                  class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
                  [options]="[order.thirdParty]"
                  [(ngModel)]="order.thirdParty"
                  optionLabel="name"
                  [filter]="false"
                  [readonly]="true"
                  filterBy="name"
                  [showClear]="false"
                  [placeholder]="'third-party' | translate"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
                    <div class="flex align-items-center gap-2">
                      <div>{{ selectedOption.name }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ item.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-justify-end tw-flex-wrap tw-gap-2">
                <div
                  *ngIf="order.outside_radius == '1' && (status.id == 0 || status.id == 1)"
                  class="tw-w-fit tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-danger/30 tw-rounded-[5px] tw-px-2"
                >
                  <p class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "outside-delivery-radius" | translate }}</p>
                </div>
                <div *ngIf="order.timeAgoString && order.timeAgoString != ''" class="tw-w-fit tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-[5px] tw-px-2">
                  <p class="tw-font-poppins tw-font-medium tw-text-sm tw-text-white">{{ order.timeAgoString }}</p>
                </div>

                <div
                  *ngIf="status.id == 0 || status.id == 1"
                  (click)="$event.stopPropagation(); deleteOrderPopup(order)"
                  class="tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-danger/30 tw-rounded-[5px] tw-cursor-pointer hover:tw-bg-danger/80"
                >
                  <img class="tw-w-4 tw-h-4 tw-object-contain" src="../../../assets/table-delete-icon.svg" />
                </div>
              </div>
            </div>
          </div>
          <div class="tw-w-full tw-h-fit tw-pb-5">
            <div
              *ngIf="status.loading"
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-bg-secondary/10 tw-flex tw-justify-center tw-items-center tw-rounded-[5px] tw-p-5"
            >
              {{ "loading" | translate }}
            </div>
            <div
              *ngIf="status.page > status.totalPages"
              class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-bg-secondary/10 tw-flex tw-justify-center tw-items-center tw-rounded-[5px] tw-p-5"
            >
              {{ "no-more-orders-to-load" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
